import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { State } from './types';

export const countriesSelector = (state: RootState) => state.amwell.system.countries;

export const countriesDataSelector = createSelector(countriesSelector, c => c.data);
export const countriesLoadingSelector = createSelector(countriesSelector, c => c.loading);
export const countriesErrorSelector = createSelector(countriesSelector, c => c.error);

export const usStatesSelector = createSelector(countriesDataSelector, data => {
  if (!data || !data.length) return [];
  const us = data.find(c => c.code === 'US');
  return ((us
    ? us.states.filter(state => state.legalAddress || state.legalResidence)
    : []) as unknown) as State[];
});
